<button
  mat-button
  type="button"
  class="btn-back btn-block"
  (click)="onBack($event)"
>
  <mat-icon style="font-size: 20px; margin: 0">arrow_back</mat-icon> Voltar
</button>
